var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSucessCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 676",
    d: "M6.66514 13.4001C10.1998 13.4001 13.0651 10.5347 13.0651 7.0001C13.0651 3.46548 10.1998 0.600098 6.66514 0.600098C3.13051 0.600098 0.265137 3.46548 0.265137 7.0001C0.265137 10.5347 3.13051 13.4001 6.66514 13.4001Z",
    fill: "#37AA00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 77555",
    d: "M5.82737 9.55253C5.75605 9.55258 5.68544 9.53842 5.61965 9.51088C5.55387 9.48333 5.49423 9.44295 5.44422 9.3921L3.46107 7.37737C3.36115 7.27553 3.30579 7.13817 3.30715 6.9955C3.30851 6.85283 3.36648 6.71655 3.46833 6.61663C3.57017 6.51671 3.70753 6.46134 3.8502 6.4627C3.99287 6.46406 4.12916 6.52204 4.22908 6.62388L5.8103 8.23327L9.08796 4.62367C9.18509 4.52332 9.31745 4.46471 9.45704 4.46024C9.59662 4.45576 9.73246 4.50578 9.83581 4.5997C9.93916 4.69363 10.0019 4.82409 10.0108 4.96347C10.0196 5.10284 9.97389 5.2402 9.88326 5.34645L6.22417 9.37673C6.17513 9.4309 6.11556 9.4745 6.04909 9.50487C5.98263 9.53524 5.91066 9.55175 5.83761 9.55338L5.82737 9.55253Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSucessCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sucess-check.bdedbbfb.svg";
export { ForwardRef as ReactComponent };